import { FC } from 'react';

import { FallbackProps } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { Link } from '@mui/material';

import AccessDenied from '@/components/shared/AccessDenied';
import { email } from '@/config';

const AppErrorBoundaryFallback: FC<FallbackProps> = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  return (
    <AccessDenied
      title="Oops! Something Went Wrong"
      description={
        <>
          It seems we’re having trouble loading the page you are looking for. If
          you believe this is an error, reach out to your organization’s
          administrator or contact{' '}
          <Link href={`mailto:${email}`} sx={{ color: 'primary.main' }}>
            {email}
          </Link>{' '}
          for help.
        </>
      }
      actionButtons={{
        primary: {
          label: 'Go Back',
          onClick: () => navigate(-1),
        },
        secondary: {
          label: 'Log Out',
          onClick: () => logout(),
        },
      }}
    />
  );
};

export default AppErrorBoundaryFallback;
